// @flow strict

import React, { type Node } from 'react';

import { useLanguageContext } from '~contexts/language-context';

import * as styles from './video.module.less';

/**
 * Type of component properties
 */
type VideoProps = {
  title: string,
  description: string,
  src: string,
  image: string,
  uploaddate: string,
};

/**
 * Render video with fallback.
 *
 * @param {VideoProps} props - Component properties
 *
 * @returns {Node}
 */
export const Video = ({ src, image }: VideoProps): Node => {
  const { loc } = useLanguageContext();

  return (
    <div className={styles.wrapper}>
      <video
        src={src}
        controls
        preload="metadata"
        poster={image}
        autoPlay
        loop
        muted
      >
        <a rel="noreferrer noopener" href={src}>
          {loc('_video_fallback')}
        </a>
      </video>
    </div>
  );
};
